module.exports = __webpack_public_path__ + "static/img/6.8e08226.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/zh/6.png
// module id = 6K8U
// module chunks = 0